import { memo } from 'react';
import type { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { SectionTitle } from "../../common/SectionTitle/SectionTitle";
import classes from './ExpertVoice.module.scss';

import expertPhoto from "../../../assets/images/expert_suzuki.webp";

interface Props {
  photo?: string;
}

export const ExpertVoice: FC<Props> = memo(function ExpertVoice({ photo = expertPhoto }) {
  const { t } = useTranslation();

  return (
    <section className={classes.root}>
      <SectionTitle classes={{ color: "grad" }} text={t('about:expertVoice.sectionTitle')} />

      <div className={`${classes.card} contentWidth`}>
        {photo ? (
          <img src={photo} alt="" className={classes.photo} />
        ) : (
          <span className={`${classes.photo} ${classes.photoPlaceholder}`}>
            <i className="fas fa-user" />
          </span>
        )}

        <h3 className={classes.heading}><Trans i18nKey="about:expertVoice.heading" /></h3>
        <p className={classes.person}>
          <span className={classes.affiliation}>{t('about:expertVoice.affiliation')}</span>
          <span className={classes.name}>{t('about:expertVoice.name')}</span>
        </p>
        <div className={classes.body}><Trans i18nKey="about:expertVoice.body" /></div>
      </div>
    </section>
  );
});
